import { jsx as _jsx } from "react/jsx-runtime";
import { useServerStorage, } from './useServerStorage';
/**
 * Higher-order component that injects server storage prop into the wrapped
 * component to make it possible for class components benefit from
 * {@link useServerStorage}.
 *
 * @param scope The server storage scope.
 * @param propName The prop name to use for the server storage value.
 * @returns The enhanced component.
 */
export const withServerStorage = ({ scope, propName, }) => {
    return ((Component) => {
        const EnhancedComponent = (props) => {
            const storage = useServerStorage(scope);
            const storageProp = {
                [propName]: storage,
            };
            return _jsx(Component, Object.assign({}, storageProp, props));
        };
        EnhancedComponent.displayName = `${propName}${Component.displayName}`;
        return EnhancedComponent;
    });
};
